var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUiuxDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6364 2H8.36364C4.2 2 2 4.2 2 8.36364V20.1818C2 20.664 2.19156 21.1265 2.53253 21.4675C2.87351 21.8084 3.33597 22 3.81818 22H15.6364C19.8 22 22 19.8 22 15.6364V8.36364C22 4.2 19.8 2 15.6364 2ZM10.4909 17.0909L8.86364 17.5182C8.70082 17.564 8.53275 17.5884 8.36364 17.5909C8.16901 17.5939 7.9757 17.5585 7.79476 17.4867C7.61382 17.415 7.44879 17.3083 7.30909 17.1727C7.12075 16.9701 6.98953 16.7211 6.92884 16.4512C6.86815 16.1813 6.88016 15.9001 6.96364 15.6364L7.39091 14.0091C7.51594 13.5744 7.74713 13.1777 8.06364 12.8545L11.5545 9.36364C12.2118 10.9799 13.4282 12.306 14.9818 13.1L11.6455 16.4364C11.3204 16.7463 10.9238 16.9711 10.4909 17.0909ZM16.3636 11.7091C15.571 11.4088 14.8592 10.9279 14.2848 10.3046C13.7104 9.6813 13.2892 8.93268 13.0545 8.11818C13.0333 8.05909 13.0026 8.00383 12.9636 7.95455C14.7182 6.33636 16.0545 7.14545 16.7 7.79091C17.3455 8.43636 18.2091 9.86364 16.3636 11.7091Z",
    fill: "#FF8C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiuxDesign);
export default __webpack_public_path__ + "static/media/uiux-design.7dceca03451f8068b1b6daf10e29ea19.svg";
export { ForwardRef as ReactComponent };